<child-header title="Edit Newsletter Name" (closeEvent)="onNoClick()"></child-header>
<div class="mat-dialog-body">
  <div mat-dialog-content>
    <textarea style="width: 445px;height: 100px;" [(ngModel)]="data.nl_title"></textarea>
  </div>
  <div mat-dialog-actions>
    <button mat-button class="button button-red button-mid" (click)="saveBlockContent()">Save</button>
    <button mat-button class="button button-red button-mid" (click)="onNoClick()">Cancel</button>
  </div>
</div>
